import { _ } from "../../polyglot/polyglot.js";
import { select } from "../../elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import controlGroup from "../forms/controlGroup.js";
import DateRangePickerWidget from "../DateRangePickerWidget/DateRangePickerWidget.js";

/**
 * Widget to select a fiscal year. Among the fiscal years available, `nextFiscalYear`
 * is a yet-to-be-created fiscal year.
 * When this peculiar fiscal year is selected, its range is displayed.
 *
 * @param {formWidget} form - Form widget attached to this widget
 * @param {FiscalYear[]}availableFiscalYears - Fiscal years from which to pick
 * @param {FiscalYear} nextFiscalYear - The yet-to-be-created fiscal year
 * @param {function} onChange - Callback invoked with the selected fiscal year
 */
export default class FiscalYearPickerWidget extends Widget {
	constructor({ form, nextFiscalYear, onChange, availableFiscalYears }) {
		super(...arguments);

		this._nextFiscalYear = nextFiscalYear;
		this._onChange = onChange;
		form.fields.push(this);

		this._range = {
			startDate: this._nextFiscalYear.getStart(),
			endDate: this._nextFiscalYear.getEnd(),
		};

		// Hack to insert ES6 class into klassified widget hierarchy
		this.model = this;

		this._fiscalYearItems = availableFiscalYears.map((year, index) => ({
			label: index === 0 ? _("Next fiscal year") : year.toSmartString(),
			value: year,
		}));

		this._selectedFiscalYear = this._fiscalYearItems[0].value;

		this._formInput = new DateRangePickerWidget({
			triggerOnChange: true,
			startDate: this._range.startDate,
			endDate: this._range.endDate,
			maxDate: null,
			cssClass: "fiscal-year-range-picker",
		});

		this._formGroup = controlGroup({
			label: _("Range"),
		});

		this._formGroup.append(this._formInput);

		this._formInput.onDateRangeChanged.register((range) => {
			this._range = range;
		});
	}

	mutator(fiscalYear) {
		this._onChange(fiscalYear, this._range);
	}

	getValue() {
		return this._selectedFiscalYear;
	}

	enabled() {
		return true;
	}

	validate() {
		return true;
	}

	renderContentOn(html) {
		html.render(this._makeFiscalYearGroup());

		if (this._selectedFiscalYear === this._nextFiscalYear) {
			html.render(this._formGroup);
		}
	}

	_makeFiscalYearGroup() {
		return controlGroup({
			label: _("Fiscal year"),
			objects: [this._makeFiscalYearDropdown()],
		});
	}

	_makeFiscalYearDropdown() {
		return select({
			class: "form-control",
			ref: (ref) => ref.setAttribute("name", "fiscal-year-picker"),
			items: this._fiscalYearItems,
			selected: this._selectedFiscalYear,
			onChange: (value) => {
				this._selectedFiscalYear = value;
				this.update();
			},
		});
	}
}
